$mol_view_tree2_to_js_test_ex_structural_with_inheritance_foo $mol_object
	field *
		xxx 123
		xxy \test

$mol_view_tree2_to_js_test_ex_structural_with_inheritance_bar $mol_view_tree2_to_js_test_ex_structural_with_inheritance_foo
	field *
		yyy 234
		^
		zzz 345
